<script setup lang="ts">
import { computed } from 'vue'
export interface Props {
  checked: boolean
}

const props = defineProps<Props>()
 interface Icon {
  name: string
  class: string
}

const icon = computed(() => {
  const icon: Icon = {}

  if (props.checked === true) {
    icon.name = 'tabler-circle-check'
    icon.class = 'text-green-500 size-6'
  } else {
    icon.name = 'tabler-circle-x'
    icon.class = 'text-red-500 size-6'
  }

  return icon
})

</script>

<template>
  <div class="flex items-center space-x-1 text-base text-black">
    <div class="flex-none">
      <storm-ui-icon
        :name="icon.name"
        :class="icon.class"
      />
    </div>
    <div class="flex-1">
      <slot />
    </div>
  </div>
</template>
